<template>
  <b-row class="d-flex align-items-stretch">
    <b-col
      v-for="(event, index) in events"
      :key="index"
      cols="12"
      md="6"
      xl="4"
      class="mb-md-5 mb-3"
    >
      <div class="event-card d-flex flex-column">
        <div class="event-header" :class="[getBackgroundClass(event.category)]">
          <div
            class="d-inline-flex align-items-center justify-content-center category-tag"
          >
            <b-img
              :src="
                'https://res.cloudinary.com/oredev/image/upload/v1716803684/2025/Icons/' +
                event.category
              "
              alt=""
              aria-hidden="true"
            />
            <span>{{ event.category }}</span>
          </div>
          <div class="event-title">{{ event.title }}</div>
        </div>
        <div class="flex-grow-1 d-flex flex-column justify-content-between">
          <div>
            <div
              class="event-tag mr-2 d-inline-flex align-items-center justify-content-center"
            >
              <b-img
                src="https://res.cloudinary.com/oredev/image/upload/v1716803684/2025/Icons/calendar.svg"
                class="mr-1"
                aria-hidden="true"
                alt=""
              />
              <span>{{ event.date }}</span>
            </div>
            <div
              class="event-tag mr-2 d-inline-flex align-items-center justify-content-center"
            >
              <b-img
                src="https://res.cloudinary.com/oredev/image/upload/v1716803684/2025/Icons/clock.svg"
                class="mr-1"
                aria-hidden="true"
                alt=""
              />
              <span>{{ event.time }}</span>
            </div>
            <div
              class="event-tag d-inline-flex align-items-center justify-content-center"
            >
              <b-img
                src="https://res.cloudinary.com/oredev/image/upload/v1716803684/2025/Icons/location.svg"
                class="mr-1"
                aria-hidden="true"
                alt=""
              />
              <span>{{ event.location }}</span>
            </div>

            <p class="mt-2">{{ event.summary }}</p>
          </div>
          <a
            :href="event.url"
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn-lime-green event-button"
          >
            Sign up to the event
          </a>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  data() {
    return {
      // Change category for automatic background color and image. Please spell it correctly :)
      events: [
        {
          url: "https://www.oredev.org",
          category: "Networking",
          title: "AI Pair Programming with Github Copilot by Foo Café.",
          date: "June 20",
          time: "9:15 am - 9:40 ",
          location: "Slagthuset, Carlsgatan 12a, 21120 Malmö",
          summary:
            "In this session, you will learn about how Github Copilot can assist developers in their day-to-day programming i.e jumpstart a new project with a new code base as the starting foundation, faster & more efficient error resolution & enhanced code quality by suggesting code improvements.",
        },
        {
          url: "https://www.oredev.org",
          category: "Interaction",
          title: ".NET Skåne November - Øredev warmup 🥂",
          date: "June 20",
          time: "9:15 am - 9:40",
          location: "Corechange, Malmborgsgatan 7 · Malmö",
          summary:
            "This is your chance to get a sneak peek of what's to come at the Øredev conference, connect with fellow developers, and get energized for the big event. Join us for an evening filled with insightful talks, networking, and great company. Whether you're attending Øredev or just want to learn and mingle with the community, this event is the perfect warmup!!",
        },
        {
          url: "https://www.oredev.org",
          category: "Entertainment",
          title: "Øredev + Devoteam's After Work",
          date: "June 20",
          time: "9:15 am - 9:40",
          location:
            "Skybar @ Malmö Arena Hotel, 12 Hyllie Boulevard 215 32 Väster",
          summary:
            "Network with fellow tech enthusiasts, unwind after a day of learning, and enjoy great company. This in-person event is the perfect opportunity to connect with like-minded individuals in a relaxed setting.",
        },
        {
          url: "https://www.oredev.org",
          category: "Knowledge",
          title: "The Ground X Øredev+ Cozy Get Together AW",
          date: "June 20",
          time: "9:15 am - 9:40",
          location: "Slagthuset, Carlsgatan 12a, 21120 Malmö",
          summary:
            "In this session, you will learn about how Github Copilot can assist developers in their day-to-day programming i.e jumpstart a new project with a new code base as the starting foundation, faster & more efficient error resolution & enhanced code quality by suggesting code improvements.",
        },
        {
          url: "https://www.oredev.org",
          category: "Interaction",
          title: ".NET Skåne November - Øredev warmup 🥂",
          date: "June 20",
          time: "9:15 am - 9:40",
          location: "Corechange, Malmborgsgatan 7 · Malmö",
          summary:
            "This is your chance to get a sneak peek of what's to come at the Øredev conference, connect with fellow developers, and get energized for the big event. Join us for an evening filled with insightful talks, networking, and great company. Whether you're attending Øredev or just want to learn and mingle with the community, this event is the perfect warmup!!",
        },
        {
          url: "https://www.oredev.org",
          category: "Entertainment",
          title: "Øredev + Devoteam's After Work",
          date: "June 20",
          time: "9:15 am - 9:40",
          location:
            "Skybar @ Malmö Arena Hotel, 12 Hyllie Boulevard 215 32 Väster",
          summary:
            "Network with fellow tech enthusiasts, unwind after a day of learning, and enjoy great company. This in-person event is the perfect opportunity to connect with like-minded individuals in a relaxed setting.",
        },
      ],
    };
  },
  methods: {
    getBackgroundClass(cat) {
      switch (cat) {
        case "Networking":
          return "bg-mint";
        case "Interaction":
          return "bg-bright-yellow";
        case "Entertainment":
          return "bg-purple";
        case "Knowledge":
          return "bg-orange";
        default:
          return "bg-light-grey"; // fallback class
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/styles/variables.scss" as *;

.event-header {
  height: 158px;
  padding: 24px;
  margin-bottom: 16px;

  font-family: Lexend, sans-serif;
  font-size: 16px;
  line-height: 23px;
  letter-spacing: 0%;
  .category-tag {
    font-weight: 300;
    img {
      width: 24px;
      margin-right: 4px;
    }
  }
  .event-title {
    font-weight: 500;
  }
}

.event-tag {
  font-family: Lexend, sans-serif;
  background-color: $light-grey;
  font-size: 14px;
  font-weight: 300;
  line-height: 1.2;
  padding: 5px 8px;
  border-radius: 5px;
  margin-bottom: 8px;
}
.event-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  box-shadow: 0px 4px 15px 0px #00000033;
  padding: 24px;

  p {
    letter-spacing: 0.05rem;
  }
}
.event-button {
  font-weight: 400;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0.05rem;
}
</style>



// WEBPACK FOOTER //
// src/components/OredevPlusEvents.vue